// Minimal dictionary for error pages to avoid bundling large i18n files
// This file is safe to import in Client Components (like error.tsx)

export const errorMessages = {
  en: {
    title: '500',
    subtitle: 'Something went wrong',
    description:
      'We apologize for the inconvenience. An unexpected error occurred.',
    button: 'Try again',
  },
  es: {
    title: '500',
    subtitle: 'Algo salió mal',
    description:
      'Pedimos disculpas por las molestias. Ha ocurrido un error inesperado.',
    button: 'Intentar de nuevo',
  },
} as const;

// Define a generic shape instead of using 'typeof errorMessages.en'
// This avoids enforcing literal string types (e.g., expecting "Something went wrong") on other languages.
export type ErrorDictionary = {
  title: string;
  subtitle: string;
  description: string;
  button: string;
};
